import React from "react";
import Table from "sc/ui/components/Table";
import { scheduleStatusPageLoad } from "../../actions/schedule-status";
import {
  scheduleStatus,
  scheduleStatusLoadInProgress,
} from "../../selectors/schedule-status";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import { Glyphicon } from "react-bootstrap";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default connect(
  (state, ownProps) => ({
    scheduleStatus: scheduleStatus(state),
    loading: scheduleStatusLoadInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(scheduleStatusPageLoad()),
    onViewSchedule: id => dispatch(push(`/schedule/${id}`)),
  }),
)(
  componentWithLoadTrigger(props => {
    const actions = [
      {
        id: "view-schedule",
        text: " Calendar",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-eye-open",
        onClick: props.onViewSchedule,
      },
    ];

    const columns = [
      {
        data: scheduleStatus => scheduleStatus.name,
      },
      {
        header: "Current month",
        tdProps: { className: "text-center" },
        data: scheduleStatus =>
          scheduleStatus.currentMonthFilled === true ? (
            <Glyphicon glyph="glyphicon glyphicon-calendar region-status-glyph green" />
          ) : (
            <Glyphicon glyph="glyphicon glyphicon-calendar region-status-glyph red" />
          ),
      },
      {
        header: "Next month",
        tdProps: { className: "text-center" },
        data: scheduleStatus =>
          scheduleStatus.nextMonthFilled === true ? (
            <Glyphicon glyph="glyphicon glyphicon-calendar region-status-glyph green" />
          ) : (
            <Glyphicon glyph="glyphicon glyphicon-calendar region-status-glyph red" />
          ),
      },
    ];

    return (
      <div id="regions-status-page">
        <PageTitle title="Scheduling" />
        <Table
          data={props.scheduleStatus}
          columns={columns}
          actions={actions}
          identityProperty="id"
          noDataMessage="No regions defined"
          loading={props.loading}
          loadingMessage="Loading..."
        />
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-tech/ScheduleStatus.js